import React, { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider, Helmet } from "react-helmet-async";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import CustomerChatbot from "./components/CustomerChatbot";
import ErrorBoundary from "./components/ErrorBoundary";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Collections from "./pages/Collections";
import ProductDetail from "./pages/ProductDetail";
import Visit from "./pages/Visit";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import NotFound from "./pages/NotFound";
import Inventory from "./pages/Inventory";
import InventoryLogin from "./pages/InventoryLogin";
import Seller from "./pages/Seller";
import SellerLogin from "./pages/SellerLogin";

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const isInventory =
    location.pathname.startsWith("/inventory")
    || location.pathname.startsWith("/seller");
  const hideStoreLayout = isAdmin || isInventory;

  const noIndexPaths = [
    "/cart",
    "/checkout",
    "/admin",
    "/admin/login"
  ];

  const shouldNoIndex =
    noIndexPaths.includes(location.pathname)
    ||
    location.pathname.startsWith("/admin")
    ||
    isInventory;

  // Hap çdo faqe të re nga fillimi.
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }, [location.pathname]);

  useEffect(() => {
    if (hideStoreLayout) {
      return;
    }

    const lenis = new Lenis({
      autoRaf: true,
      lerp: 0.1
    });

    return () => lenis.destroy();
  }, [hideStoreLayout]);

  return (
    <>
      {shouldNoIndex && (
        <Helmet>
          <meta
            name="robots"
            content="noindex, nofollow"
          />
        </Helmet>
      )}

      {!hideStoreLayout && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/visit" element={<Visit />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/inventory/login" element={<InventoryLogin />} />
        <Route path="/inventory/admin/login" element={<InventoryLogin />} />
        <Route path="/inventory/seller/login" element={<SellerLogin />} />
        <Route path="/seller" element={<Seller />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!hideStoreLayout && <Footer />}
      {!hideStoreLayout && <CustomerChatbot />}

      <Toaster
        position="top-center"
        duration={3000}
      />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <HelmetProvider>
          <BrowserRouter>
            <Layout />
          </BrowserRouter>
        </HelmetProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
